export default "__VITE_ASSET__fBmKORlf__"